if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

if (!Shopify.resizeImage) {
  Shopify.resizeImage=function(e,t){
    try{
      if("original"==t)
        return e;
      var n = e.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
      return n[1]+"_"+t+"."+n[2]
    } catch(r) {
      return e;
    }
  }
}

// Equalize the height of the ATC bullets (Free Shipping / Free In-Home
// Delivery / etc.) so that when one of them wraps to 2 lines, all of them
// match its height instead of looking ragged. Also: when there are exactly
// 3 bullets, switch the row to justify-content:space-between so the lone
// item on row 2 doesn't look randomly placed relative to the pair above it.
// Re-run on load, on resize, and after the variant-change handler
// re-renders the bullets below.
window.cfEqualizeAtcBullets = function () {
  document.querySelectorAll('.cf-atc-bullets-wrap-legacy').forEach(function (wrap) {
    var items = wrap.querySelectorAll('.cf-atc-bullet-item-legacy');
    if (!items.length) return;

    wrap.style.justifyContent = items.length === 3 ? 'space-between' : 'center';

    items.forEach(function (el) { el.style.minHeight = ''; });
    var max = 0;
    items.forEach(function (el) { max = Math.max(max, el.offsetHeight); });
    items.forEach(function (el) { el.style.minHeight = max + 'px'; });
  });
};

(function () {
  var cfEqualizeTimeout;
  function cfScheduleEqualize() {
    clearTimeout(cfEqualizeTimeout);
    cfEqualizeTimeout = setTimeout(window.cfEqualizeAtcBullets, 100);
  }
  document.addEventListener('DOMContentLoaded', cfScheduleEqualize);
  window.addEventListener('resize', cfScheduleEqualize);
  if (document.readyState !== 'loading') cfScheduleEqualize();
})();

// Match the Trust Guard seal / Affirm message box (.second-area) to the
// exact rendered width of the Add to Cart button (.atc-btn) on child-item
// (multi-piece product) rows. Pure CSS can't express this: .atc-btn's width
// is whatever's left over after .qty in a flex row, not a fixed px/% value,
// so a fixed-width/max-width rule on .second-area never actually matched it.
// Desktop only (>=640px) — below that both stack full-width and no explicit
// width is needed, so it's cleared there instead.
window.cfEqualizeAtcWidth = function () {
  document.querySelectorAll('.ci-col-3 .atc-area').forEach(function (atcArea) {
    var btn = atcArea.querySelector('.atc-btn');
    var second = atcArea.querySelector('.second-area');
    if (!btn || !second) return;

    if (window.innerWidth < 640) {
      second.style.width = '';
      return;
    }
    var width = btn.getBoundingClientRect().width;
    if (width) second.style.width = width + 'px';
  });
};

(function () {
  var cfEqualizeWidthTimeout;
  function cfScheduleEqualizeWidth() {
    clearTimeout(cfEqualizeWidthTimeout);
    cfEqualizeWidthTimeout = setTimeout(window.cfEqualizeAtcWidth, 100);
  }
  document.addEventListener('DOMContentLoaded', cfScheduleEqualizeWidth);
  window.addEventListener('resize', cfScheduleEqualizeWidth);
  if (document.readyState !== 'loading') cfScheduleEqualizeWidth();
})();

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
  // FastClick.attach(document.body); 
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  //timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
};

function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

$(document).ready(function() {

if (is_touch_device() || $(window).width() <= 800) {

  // Click

  $(document).click(function(){
    if($('.ysw-tooltip').is(':visible')) {
    	$('a.tooltip-popup-1').tooltip('close');
    }
  });

  $(document).on('click','a.tooltip-popup-1', function(e){
    e.stopPropagation();
  });

  $('a.tooltip-popup-1').click(function() {

    if($('.ysw-tooltip').is(':visible')) {

      $('a.tooltip-popup-1').tooltip('close');
      $(this).tooltip("open");

    } else {

      $(this).tooltip("open");
    }
  });

} else {

  // Hover

}

});

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';


  function is_touch_device() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  };

  if (is_touch_device() || $(window).width() <= 800) {

    // Click

    $(document).on('click', 'ul.site-nav > li.site-nav--has-dropdown > a', function() {

      var thisLi = $(this).closest('li');

      $('ul.site-nav > li.site-nav--has-dropdown').not(thisLi).removeClass(activeClass);
      thisLi.toggleClass(activeClass);
      return false;

    });


  } else {

    // Hover

    // Mouseenter
    $parents.on('mouseenter touchstart', function(evt) {
      var $el = $(this);

      if (!$el.hasClass(activeClass)) {
        evt.preventDefault();
      }

      showDropdown($el);
    });

    // Mouseout
    $parents.on('mouseleave', function() {
      hideDropdown($(this));
    });

    $subMenuLinks.on('touchstart', function(evt) {
      // Prevent touchstart on body from firing instead of link
      evt.stopImmediatePropagation();
    });

    $allLinks.focus(function() {
      handleFocus($(this));
    });

    $allLinks.blur(function() {
      removeFocus($topLevel);
    });

  }



  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function toggleDropdown ($el) {
    $el.toggleClass(activeClass);
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};
timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector,
      product_id = options.product_id;

  var $productImage = $('#AddToCartForm--'+product_id+' #ProductPhotoImg'),
      $addToCart = $('#AddToCartForm--'+product_id+' #AddToCart'),
      $productPrice = $('#AddToCartForm--'+product_id+' #ProductPrice'),
      $comparePrice = $('#AddToCartForm--'+product_id+' #ComparePrice'),
      $comparePriceClass = $('#AddToCartForm--'+product_id+' .ComparePrice'),
      $youSave = $('#AddToCartForm--'+product_id+' #YouSave'),
      $quantityElements = $('#AddToCartForm--'+product_id+' .quantity-selector, #AddToCartForm--'+product_id+' .js-qty'),
      $addToCartText = $('#AddToCartForm--'+product_id+' #AddToCartText');
  	  $addToCartTextPopup = $('#quick-view #AddToCartForm--'+product_id+' #AddToCartText');
  	  $addToCartTextProduct = $('.template-product #AddToCartForm--'+product_id+' #AddToCartText');var atcIconHtml = "\u003cimg src=\"\/\/www.clubfurniture.com\/cdn\/shop\/t\/182\/assets\/cart-button-icon-new2.jpg?v=148680921404201713681790603629\" alt=\"+\" class=\"no-border normal-img addIcon\"\u003e";

  if (variant) {
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0],
          variant_id = newImg.variant_ids[0];
      var variant_img = $('#productSelect--'+product_id).find('option[value="'+variant_id+'"]').data('image');
      $("#bx-pager-"+product_id).find('img[src="'+variant_img+'"]').parent("a").trigger('click');
      var li = $("#bx-pager-"+product_id).find('img[src="'+variant_img+'"]').parent("a").parent('li');
      var clickindex = $("#bx-pager-"+product_id+" li").index(li) + 1;
      var currentWidth = $(li).parent('ul').parent('div').css('max-width');
      var currentWidthParent = $(li).parent('ul').parent('div').parent('div').css('max-width');
      var cPage = 1;
      if(currentWidth == "170px" || currentWidthParent == "170px"){
        cPage = Math.ceil(clickindex / 2);
      } else if(currentWidth == "260px" || currentWidthParent == "260px"){
        cPage = Math.ceil(clickindex / 3);
      } else if(currentWidth == "350px" || currentWidthParent == "350px"){
        cPage = Math.ceil(clickindex / 4);
      }
      cPage = cPage - 1;
      $(li).parent('ul').parent('div').parent('div').find('a[data-slide-index="'+cPage+'"]').trigger('click');
    }

    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );
    if (variant.available) {
      $addToCart.removeClass('disabled').prop('disabled', false);
      
        $addToCartText.html(
          atcIconHtml +
          "Add to Cart" +
          '<style>' +
            'html body span#AddToCartText:after{' +
              'content:none!important;' +
              'display:none!important;' +
            '}' +
            '#AddToCart{' +
              'height:auto!important;' +
              'min-height:105px!important;' +
              'padding-top:14px!important;' +
              'padding-bottom:14px!important;' +
            '}' +
            '.cf-atc-bullet-item-legacy{' +
              'flex:0 1 calc(50% - 5px)!important;' +
            '}' +
            '.cf-atc-bullets-wrap-legacy{' +
              'width:90%!important;' +
              'margin:auto!important;' +
            '}' +
            '@media(min-width:900px){' +
            '.cf-atc-bullet-item-legacy{' +
              'flex:0 1 calc(45% - 5px)!important;' +
            '}'+
              '.cf-atc-bullets-wrap-legacy{' +
                'width:80%!important;' +
                'margin:0 auto!important;' +
              '}' +
            '}' +
          '</style>' +
          '<hr style="display:block!important;border:none!important;border-top:1px solid #fff!important;width:100%!important;margin:4px 0!important;height:0!important;padding-bottom:0.5rem!important">' +
          '<div class="cf-atc-bullets-wrap-legacy" style="display:flex!important;flex-wrap:wrap!important;justify-content:center!important;column-gap:10px!important;row-gap:4px!important;font-size:13px!important;font-weight:400!important;color:#fff!important;text-transform:none!important;line-height:1.3!important;">' +'<span class="cf-atc-bullet-item-legacy" style="display:flex!important;align-items:center!important;justify-content:flex-start!important;gap:6px!important;font-size:13px!important;font-weight:400!important;color:#fff!important;min-width:0!important;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" style="flex-shrink:0!important;"><circle cx="12" cy="12" r="10" fill="#fff"/><path d="M7 12.5l3 3 7-7" stroke="#559f30" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span style="min-width:0!important;overflow-wrap:break-word!important;word-break:break-word!important;">FREE Shipping</span></span>' +'<span class="cf-atc-bullet-item-legacy" style="display:flex!important;align-items:center!important;justify-content:flex-start!important;gap:6px!important;font-size:13px!important;font-weight:400!important;color:#fff!important;min-width:0!important;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" style="flex-shrink:0!important;"><circle cx="12" cy="12" r="10" fill="#fff"/><path d="M7 12.5l3 3 7-7" stroke="#559f30" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span style="min-width:0!important;overflow-wrap:break-word!important;word-break:break-word!important;">FREE In-Home Delivery</span></span>' +'<span class="cf-atc-bullet-item-legacy" style="display:flex!important;align-items:center!important;justify-content:flex-start!important;gap:6px!important;font-size:13px!important;font-weight:400!important;color:#fff!important;min-width:0!important;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" style="flex-shrink:0!important;"><circle cx="12" cy="12" r="10" fill="#fff"/><path d="M7 12.5l3 3 7-7" stroke="#559f30" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span style="min-width:0!important;overflow-wrap:break-word!important;word-break:break-word!important;">Style, Comfort &amp; Quality</span></span>' +'<span class="cf-atc-bullet-item-legacy" style="display:flex!important;align-items:center!important;justify-content:flex-start!important;gap:6px!important;font-size:13px!important;font-weight:400!important;color:#fff!important;min-width:0!important;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" style="flex-shrink:0!important;"><circle cx="12" cy="12" r="10" fill="#fff"/><path d="M7 12.5l3 3 7-7" stroke="#559f30" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span style="min-width:0!important;overflow-wrap:break-word!important;word-break:break-word!important;">&quot;Buy-It-Back&quot; Guarantee</span></span>' +'</div>'
        );
        setTimeout(window.cfEqualizeAtcBullets, 50);
      
      
      
      /*$quantityElements.show();*/
    } else {
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold Out");
      $productPrice.html("Sold Out");
      $comparePrice.hide();
      $comparePriceClass.hide();
      
        $youSave.hide();
      
      /*$quantityElements.hide();*/
    }

    if (variant.compare_at_price > variant.price) {
      $comparePrice.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat)).show();
      $comparePriceClass.show();
      
      var per = ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price;
      $youSave.html('You Save: <b id="save_value-'+product_id+'">'+Shopify.formatMoney((variant.compare_at_price - variant.price), moneyFormat)+' ('+ Math.round(per) +'%)</b>').show();
      
    } else {
      $comparePrice.hide();
      $comparePriceClass.hide();
      
        $youSave.hide();
      
    }
  } else {
    $comparePrice.hide();
    $comparePriceClass.hide();
    
      $youSave.hide();
    
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Sold Out");
    $productPrice.html("Sold Out");
    /*$quantityElements.hide();*/
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // Notify the drawer has opened
    timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    timber.cache.$body.trigger('beforeDrawerClose.timber', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // Notify the drawer is closed now
    timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

function addEvent(obj, evt, fn) {
  if (obj.addEventListener) {
    obj.addEventListener(evt, fn, false);
  } else if (obj.attachEvent) {
    obj.attachEvent("on" + evt, fn);
  }
}

Date.prototype.addHours= function(h){
  this.setHours(this.getHours()+h);
  return this;
}

function timezone() {
  var offset = new Date().getTimezoneOffset();
  var minutes = Math.abs(offset);
  var hours = Math.floor(minutes / 60);
  var prefix = offset < 0 ? "" : "-";
  return prefix+hours;
}

$(document).on('click', '.mobile-nav__toggle-open-slide', function(e){
  e.preventDefault();
  var id = $(this).data('id');
  $(id).css('display', 'block');
  $(this).parent('div').parent('div').parent('li').parent('ul').css('left', '-100%').css('display', 'none');
  $(id).animate({
    left: "0"
  }, 4, function() {
    $(id).css('position', 'relative').css('display', 'block');
  });
});

$(document).on('click', '.mobile-nav__toggle-slide.open-parent, .mobile-nav__link.open-parent', function(e){
  e.preventDefault();
  var id = $(this).parent('div').find('.mobile-nav__toggle-open-parent').data('id');
  $(id).css('display', 'block');
  $(this).parent('div').parent('li').parent('ul').css('left', '100%').css('display', 'none');
  $(id).animate({
    left: "0"
  }, 4, function() {
    $(id).css('position', 'relative').css('display', 'block');
  });
});

timber.bxSliderApply = function (options) {
  $(".product--images").css('visibility', 'visible');
  if(options.total_images > 1) {
    $('#bxslider-id-'+options.product_id).bxSlider({
      pagerCustom: '#bx-pager-'+options.product_id,
      infiniteLoop: false,
      touchEnabled: true,
      adaptiveHeight: true
    });
    if(options.total_images > options.offset) {
      
        $('#bx-pager-'+options.product_id).bxSlider({
          infiniteLoop: false,
          slideWidth: 80,
          slideMargin: 10,
          minSlides: 3,
          maxSlides: 4
        });
      
    }
  }
};

timber.bxSliderApplyMainProduct = function (options) {
  $(".product--images").css('visibility', 'visible');
  if(options.total_images > 1) {
    $('#bxslider-id-'+options.product_id).bxSlider({
      pagerCustom: '#bx-pager-'+options.product_id,
      infiniteLoop: false,
      touchEnabled: true,
      adaptiveHeight: true,
      onSliderLoad: function() {
      	// console.log('bxslider loaded!');
      }
    });
    if(options.total_images > options.offset) {
      
        $('#bx-pager-'+options.product_id).bxSlider({
          infiniteLoop: false,
          slideWidth: 80,
          slideMargin: 10,
          minSlides: 3,
          maxSlides: 4
        });
      
    }
  }
};

timber.sliderClickCallback = function () {
  $('.product-single__thumbnail img').click(function(e){
    e.preventDefault();
    var variant_img = $(this).attr('src');
    var product_id = $(this).parent('a').parent('li').parent('ul').data('product');
    if($("#productSelect--"+product_id+" option[data-image='"+variant_img+"']").val() !== undefined && $("#productSelect--"+product_id+" option[data-image='"+variant_img+"']").attr("disabled") === undefined){
      var option1 = $("#productSelect--"+product_id+" option[data-image='"+variant_img+"']").data('option1');
      var option2 = $("#productSelect--"+product_id+" option[data-image='"+variant_img+"']").data('option2');
      var option3 = $("#productSelect--"+product_id+" option[data-image='"+variant_img+"']").data('option3');
      
      	if(option1 !== ""){
          $("#AddToCartForm--"+product_id).find("select[data-option='option1']").val(option1).change();
        }
        if(option2 !== ""){
          $("#AddToCartForm--"+product_id).find("select[data-option='option2']").val(option2).change();
        }
        if(option3 !== ""){
          $("#AddToCartForm--"+product_id).find("select[data-option='option3']").val(option3).change();
        }
      
    }
  });
};

timber.qtySelectors = function() {
  var numInputs = $('input[type="number"]');

  if (numInputs.length) {
    numInputs.each(function() {
      var $el = $(this),
          currentQty = $el.val(),
          inputName = $el.attr('name'),
          inputId = $el.attr('id');

      var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

      var source   = $("#JsQty").html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            inputName: inputName,
            inputId: inputId
          };
      $el.after(template(data)).remove();
    });

    $('.js-qty__adjust').on('click', function() {
      var $el = $(this),
          id = $el.data('id'),
          $qtySelector = $el.siblings('.js-qty__num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {

      } else {
        qty = 1;
      }

      if ($el.hasClass('js-qty__adjust--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 1) qty = 1;
      }

      $qtySelector.val(qty);
    });
  }
};

timber.swatchChange = function () {
  $('.swatch :radio').change(function() {
    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
    var optionValue = $(this).val();
    $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
  });
};


  timber.magniflierImageZoom = function () {
    if ($('.magniflier').length) {
      if($(window).width() > 991){
        $(function() {
          var native_width = 0;
          var native_height = 0;
          var mouse = {x: 0, y: 0};
          var magnify;
          var cur_img;

          var ui = {
            magniflier: $('.magniflier')
          };

          if (ui.magniflier.length) {
            var div = document.createElement('div');
            div.setAttribute('class', 'glass');
            ui.glass = $(div);
            $('body').append(div);
          }

          var mouseMove = function(e) {
            var $el = $(this);
            var magnify_offset = cur_img.offset();
            mouse.x = e.pageX - magnify_offset.left;
            mouse.y = e.pageY - magnify_offset.top;
            if ( mouse.x < cur_img.width() && mouse.y < cur_img.height() && mouse.x > 0 && mouse.y > 0 ) {
              magnify(e);
            } else {
              ui.glass.fadeOut(100);
            }
            return;
          };

          var magnify = function(e) {
            var rx = Math.round(mouse.x/cur_img.width()*native_width - ui.glass.width()/2)*-1;
            var ry = Math.round(mouse.y/cur_img.height()*native_height - ui.glass.height()/2)*-1;
            var bg_pos = rx + "px " + ry + "px";
            // var glass_left = mouse.x - ui.glass.width() / 2;
            // var glass_top  = mouse.y - ui.glass.height() / 2;
            var glass_left = e.pageX - ui.glass.width() / 2;
            var glass_top  = e.pageY - ui.glass.height() / 2;
            ui.glass.css({
              left: glass_left,
              top: glass_top,
              backgroundPosition: bg_pos
            });
            return;
          };

          $('.magniflier').on('mousemove', function() {
            ui.glass.fadeIn(100);
            cur_img = $(this);
            var large_img_loaded = cur_img.data('large-img-loaded');
            var src = cur_img.data('large') || cur_img.attr('src');
            if (src) {
              ui.glass.css({
                'background-image': 'url(' + src + ')',
                'background-repeat': 'no-repeat'
              });
            }
            if (!cur_img.data('native_width')) {
              var image_object = new Image();
              image_object.onload = function() {
                native_width = image_object.width;
                native_height = image_object.height;
                cur_img.data('native_width', native_width);
                cur_img.data('native_height', native_height);
                mouseMove.apply(this, arguments);
                ui.glass.on('mousemove', mouseMove);
              };
              image_object.src = src;
              return;
            } else {
              native_width = cur_img.data('native_width');
              native_height = cur_img.data('native_height');
            }
            mouseMove.apply(this, arguments);
            ui.glass.on('mousemove', mouseMove);
          });

          addEvent(window,"load",function(e) {
            addEvent(document, "mouseout", function(e) {
              e = e ? e : window.event;
              var from = e.relatedTarget || e.toElement;
              if (!from || from.nodeName == "HTML") {
                ui.glass.fadeOut(100);
              }
            });
          });

          $('.site-header').hover(function(){
            ui.glass.fadeOut(100);
          });

          $('.glass').click(function(){
            ui.glass.fadeOut(100);
          });

          ui.glass.on('mouseout', function() {
            ui.glass.off('mousemove', mouseMove);
          });

        });
      }
    }
  };


timber.progressStriped = function () {
  if ($('.progress.progress-striped').length) {
    $('.progress.progress-striped').each(function() {
      var qty = $(this).data('qty');
      var cnt = $(this).data('total');
      var pct = Math.ceil(100 * (cnt / qty));
      if (pct >= 100) {
        pct = 100;
      }
      if (pct >= 75) {
        $(this).find('.progress-bar').addClass('progress-bar-danger');
      }
      $(this).find('.progress-bar').css('width',pct + '%');
    });
  }
};

timber.fancybox = function () {
  if ($('.fancybox').length) {
    if($(window).width() > 767) {
      $('.fancybox').fancybox({
        afterShow: function( instance, slide ) {

          if($('.fancybox-container .fancybox-content').length > 0) {
      // Iframe
      $('.fancybox-container .fancybox-toolbar').appendTo('.fancybox-container .fancybox-content')
    } else {
      // Image
      $('.fancybox-container .fancybox-toolbar').appendTo('.fancybox-container .fancybox-image-wrap')
    }

        }
      });
      $('body').on('click', '.glass', function(){
        var data_index = $('.product-single__thumbnails').find('.active').data('slide-index');
        $(".product-single__photos a[data-index-slide='" + data_index + "']").trigger('click');
      });
    } else {
      $('.fancybox').click(function(e) {
        e.preventDefault();
      });
    }
  }
};

timber.stopSelling = function (options) {
  if (options.action == "text") {
    $('#countdown-timer-'+options.product_id+' .header').html("");
    $('#countdown-timer-'+options.product_id+' .countdown').remove();
  }
};

timber.countDownTimerExtend = function (options) {
  if (options.pub - options.now > 0) {
    $('#countdown-timer-'+options.product_id+' .countdown').downCount({
      date: options.pub,
      offset: timezone()
    }, function () {
      timber.stopSelling({
        action: 'text',
        product_id: options.product_id
      });
    });
  } else {
    options.pub.addHours(options.exp);
    timber.countDownTimerExtend({
      now: options.now,
      exp: options.exp,
      pub: options.pub,
      product_id: options.product_id
    });
  }
};

timber.countDownTimer = function (options) {
  if ($('#countdown-timer-'+options.product_id).length) {
    var now = new Date();
    var exp = $('#countdown-timer-'+options.product_id).data('expire');
    var pub = new Date($('#countdown-timer-'+options.product_id).data('published'));
    if (pub - now > 0) {
      $('#countdown-timer-'+options.product_id+' .countdown').downCount({
        date: pub,
        offset: timezone()
      }, function () {
        timber.stopSelling({
          action: 'text',
          product_id: options.product_id
        });
      });
    } else {
      pub.addHours(exp);
      timber.countDownTimerExtend({
        now: now,
        exp: exp,
        pub: pub,
        product_id: options.product_id
      });
    }
  }
};

timber.countDownFlipTimer = function (options) {
  if ($('#countdown-timer-'+options.product_id).length) {
    var now = new Date();
    var exp = $('#countdown-timer-'+options.product_id).data('expire');
    var pub = new Date($('#countdown-timer-'+options.product_id).data('published'));
    if (pub - now > 0) {
      var clock = $('#countdown-timer-'+options.product_id).FlipClock(((pub - now) / 1000), {
        countdown: true
      });
    } else {
      pub.addHours(exp);
      timber.countDownFlipTimerExtend({
        now: now,
        exp: exp,
        pub: pub,
        product_id: options.product_id
      });
    }
  }
};

timber.countDownFlipTimerExtend = function (options) {
  if (options.pub - options.now > 0) {
    var clock = $('#countdown-timer-'+options.product_id).FlipClock(((options.pub - options.now) / 1000), {
      countdown: true,
      clockFace: 'DailyCounter'
    });
  } else {
    options.pub.addHours(options.exp);
    timber.countDownFlipTimerExtend({
      now: options.now,
      exp: options.exp,
      pub: options.pub,
      product_id: options.product_id
    });
  }
};

timber.visitorCounter = function () {
  if ($('#visitor_counter_visitors').length) {
    var min = 124;
    var max = 146;
    min = Math.ceil(min);
    max = Math.floor(max);
    var r = Math.floor(Math.random() * (max - min + 1)) + min;
    var inc = '1';
    var myRandom = ['1', '2', '3', '4', '5','10', '-1', '-2', '-3', '-4', '-5'];
    var randomlyValue='';
    var currentmyRandom='';
    var plus = ['10', '20', '15'];
    var range='';

    setInterval(function(){
      randomlyValue =  Math.floor(Math.random() * myRandom.length);
      currentmyRandom = myRandom[randomlyValue];
      r = parseInt(r) + parseInt(currentmyRandom);
      if(r <= min){
        r = min;
      }
      if(r > max){
        r = max;
      }
      jQuery("#visitor_counter_visitors").html(r);
    }, 2000);
  }
};

timber.buildTabs = function (options) {
  $(".tabs").tabs({ active: options.default });
  var ariacontrols = $('.ui-state-active').attr('aria-controls');
  $('#onChangeTrigger').val('#'+ariacontrols);

  $('.ui-tabs-anchor').on('click', function() {
   	var ariacontrols = $(this).attr('href');
    var ariacontrolsdrop = $('#onChangeTrigger').val();
    if(ariacontrols !== '#'+ariacontrolsdrop){
      $('#onChangeTrigger').val(ariacontrols);
    }
  });

  $('#onChangeTrigger').on('change', function() {
    var ariacontrols = $(this).val();
    $('a[href="'+ariacontrols+'"]').trigger('click');
  });
  /*$('#desctiptionTabs').easyResponsiveTabs({
    type: 'default',
    width: 'auto',
    fit: true,
    tabidentify: 'desctiption--tabs'
  });*/
};

$(document).ready(function() {
  var slider, canSlide = true;
  slider = $('#homepage_slider').flexslider({
    touch: true,
    smoothHeight: true,
    
    controlNav: false,
    
      directionNav: false,
    
    animation: "fade",
    
    slideshowSpeed: 10*1000,
    before: function(){
      if(!canSlide) {
        slider.flexslider("stop");
      }
    }
  });

  

  if ($('.promotion-slider').length) {
    $(".promotion-slider").owlCarousel({
      autoPlay: 8000,
      slideSpeed: 500,
      stopOnHover: true,
      nav:true,
      responsive: {
        0: {
          items: 1
        },
        480: {
          items: 2
        },
        768: {
          items: 3
        }
      }
    });
  }

  if ($('.carousel-product').length) {
    $(".carousel-product").owlCarousel({
      autoPlay: 8000,
      slideSpeed: 500,
      stopOnHover: true,
      nav:true,
      responsive: {
        0: {
          items: 1
        },
        650: {
          items: 2
        },
        980: {
          items: 3
        },
        1220: {
          items: 4
        }
      }
    });
  }

  $('#cartAddPopup').click(function(e){
    e.preventDefault();
    window.location.href = "/cart";
  });

  $('.cart__hover').on('mouseenter', function(e) {
    if ($(window).width() > 767) {
      timber.addtocartPopupClose();
    }
  });

  $('.addCart-popup-close').on('click', function(e) {
    timber.addtocartPopupClose();
  });
});

timber.addtocartPopupClose = function () {
  $("#cartAddPopup").animate({
    top: "-200px"
  }, 500, function() {
    $("#cartAddPopup").css('visibility', 'hidden');
  });
};

timber.modalBox = function () {
	var modal;
    var modalHTML;
	var btn = $("[data-toggle='modal']");
	var close = $("[data-toggle='close-modal']");

    $(btn).click(function(e){
      e.preventDefault();
      modal = $($(this).data('target'));
      if($(window).width() > 767){
        var width = "600px";
      } else {
      	var width = "90%";
      }
      $(modal).find('.modal-content').css('width', width);
      $(modal).addClass("in");
      modalHTML = $(this).data('target').replace("#", "");
    });

    $(close).click(function(e){
      e.preventDefault();
      $(modal).removeClass("in");
    });

    window.onclick = function(event) {
      if (event.target.id == modalHTML) {
        $(modal).removeClass("in");
      }
    }
};





$( window ).resize(function() {
  $('.site-header').removeClass('sticky');
  $('.site-header .nav-bar').removeClass('sticky');
  $('.cart__footer-icon').removeClass('in');
  $('.main-content').css('padding-top', '0');
  
  	if($(window).width() > 767){
      $('#someone-purchased').show();
      $("#someone-purchased > div:gt(0)").hide();
    } else {
      $('#someone-purchased').hide();
    }
  
});

$( window ).scroll(function() {
  var scroll = $(window).scrollTop();
  if($(window).width() > 767){
    if(scroll >= 215){
      if(!$('.cart__footer-icon').hasClass('in')){
        $('.cart__footer-icon').addClass('in');
      }
    } else {
      $('.cart__footer-icon').removeClass('in');
    }
  } else {
    if(scroll >= 90){
      if(!$('.cart__footer-icon').hasClass('in')){
        $('.cart__footer-icon').addClass('in');
      }
    } else {
      $('.cart__footer-icon').removeClass('in');
    }
  }
});

timber.collectionImageSlide = function () {
  $( ".grid__image" ).mouseenter(function() {
    if ($(window).width() > 1024) {
      
        $(this).children('.first--image').css('opacity', '0');
        $(this).children('.second--image').css('opacity', '1');
      
    }
  }).mouseleave(function() {
    if ($(window).width() > 1024) {
      
        $(this).children('.first--image').css('opacity', '1');
        $(this).children('.second--image').css('opacity', '0');
      
    }
  });
};



timber.cartUpdatePopup = function (cart) {
  var cart_summary = $('#cart-popup');
  if (cart_summary.length) {
    cart_summary.empty();
    jQuery.each(cart, function(key, value) {
      if (key === 'items') {
        var $html = '';
        if (value.length) {
          $html += '<div class="container">';
          $html += '<form action="/cart" method="post">';
          $html += '<ul class="cart-popup-ul-top">';
          $html += '<li class="total-items"><b>Total: </b><span class="cart-current-items">'+cart.item_count+'</span> Items</li>';
          $html += '<li class="total-price">'+ Shopify.formatMoney(cart.total_price, window.money_format) +'</li>';
          $html += '</ul>';
          $html += '<ul class="cart-popup-ul-middle">';
          jQuery.each(value, function(i, item) {
            $html += '<li>';
            $html += '<a href="'+ item.url +'">';
            $html += '<div class="cart-img-div">';
            $html += '<img src="'+ Shopify.resizeImage(item.image, 'small') +'" alt="Image of '+ item.title +'" class="cart-item-image" />';
            $html += '<span class="pop-qty-crat">'+ item.quantity +'</span>';
            $html += '</div>';
            $html += '<div class="cart-item-info">';
            $html += '<span class="cart-item-title">'+ item.title +'</span>';
            $html += '<p class="cart-item-price">'+ Shopify.formatMoney(item.price, window.money_format) +'</p>';
            $html += '</div>';
            $html += '<a href="/cart/change?line='+(i+1)+'&quantity=0" data-line="'+(i+1)+'" class="removeLineCartPop" rel="'+ item.variant_id +'">x</a>';
            $html += '</a>';
            $html += '</li>';
          });
          $html += '</ul>';

          $html += '<ul class="cart-popup-ul-bottom">';
          $html += '<li><a href="/cart" class="btn--secondary btn--full cart__cartview">View My Cart</a></li><li>';
          $html += '<a href="/checkout" class="btn btn--full cart__checkout Checkout">';
          $html += '<img src="//www.clubfurniture.com/cdn/shop/t/182/assets/checkout-button-icon.png?v=58200824834485284121790603645" alt="" class="addIcon" />';
          $html += '<span id="CheckoutText">Checkout Now</span>';
          $html += '</a></li></ul></form></div>';
          cart_summary.removeClass('empty-popup');
        } else {
          $html = '<div class="container"><ul class="cart-popup-ul-bottom"><li class="empty-cart-popup-msg">Your cart is empty. Did you forget to add something?</li><li><a href="/collections/all" class="btn btn-large btn-primary">Shop Now</a></li></ul></div>';
          cart_summary.addClass('empty-popup');
        }
        cart_summary.append($html);
      }
    });
  }
};

timber.recordLastCollection = function (options) {
  jQuery.cookie('shopify_collection', options.collection, { path: '/' });
};

function openpopup(url,name) {
  window.open(url,name,'width=500,height=300');
}

// Initialize Timber's JS on docready
$(timber.init);

$(document).ready(function() {

// Tooltip
$('a.tooltip-popup-1').tooltip({
  tooltipClass: "ysw-tooltip",
  position: { my: "right-15 center", at: "left bottom", collision:"flipfit" },
  content: function(callback){
    callback($(this).prop('title').replace(new RegExp("\\|", 'g'), '<br />'));
  }
});

// Fancybox
$("[data-fancybox]").fancybox({
  afterShow: function( instance, slide ) {

    if($('.fancybox-container .fancybox-content').length > 0) {
      // Iframe
      $('.fancybox-container .fancybox-toolbar').appendTo('.fancybox-container .fancybox-content')
    } else {
      // Image
      $('.fancybox-container .fancybox-toolbar').appendTo('.fancybox-container .fancybox-image-wrap')
    }

  },
  thumbs : {
    showOnStart : true
  }
});

});

$(document).on('click', 'body.template-product .parent-description .view-more a', function() {
  $(this).closest('.parent-description').toggleClass('open');
});


$(document).on('click', 'body.template-product .child-mobile-view-more a', function() {
  $(this).closest('.child-item').toggleClass('open');
});


$(document).on('click', 'body.template-product .child-mobile-tabs .tab-container .title', function() {

  	var thisTabSet = $(this).closest('.child-mobile-tabs');
	var thisTabContainer = $(this).closest('.tab-container');

	thisTabContainer.toggleClass('open');

	// This Tab
	if(thisTabContainer.hasClass('open')) {
		thisTabContainer.find('.indicator').removeClass('fa-chevron-down').addClass('fa-chevron-up');
	} else {
		thisTabContainer.find('.indicator').removeClass('fa-chevron-up').addClass('fa-chevron-down');
	}

  // Other Tabs in set
  thisTabSet.find('.tab-container').not(thisTabContainer).each(function() {
    $(this).removeClass('open');
    $(this).find('.indicator').removeClass('fa-chevron-up').addClass('fa-chevron-down');
  });

});

$(document).on('click', 'body.template-collection .collection-description .view-more a', function() {
  $(this).closest('.collection-description').toggleClass('open');
});


// Footer links menu
$(document).on('click', 'footer.site-footer .second-footer .menu-footer .content-block-outer .heading', function() {

	// If mobile search is visible, then it's the mobile view...
	if($('.mobile--search').is(':visible')) {

		var thisBlock = $(this).closest('.content-block-outer');

		$('footer.site-footer .second-footer .menu-footer .content-block-outer').not(thisBlock).removeClass('current');
		thisBlock.toggleClass('current');

	}

});

$(document).ready(function() {

	function setCookie(name,value,days,domain,path) {
		if (days) {
			if (days == 0) {
				var expires = "";
			} else {
				var date = new Date();
				date.setTime(date.getTime()+(days*24*60*60*1000));
				var expires = "; expires="+date.toGMTString();
			}
		}
		else var expires = "";
		if (domain) {
			var cdomain = "; domain=" + domain;
		} else {
			var cdomain = "";
		}
		if (path) {
			var cpath = "; path=" + path;
		} else {
			var cpath = "; path=/";
		}
		document.cookie = name+"="+encodeURIComponent(value)+expires+cdomain+cpath;
	}

	function eraseCookie(name, domain, path) {
		setCookie(name,"",-1, domain, path);
	}

	function getCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return decodeURIComponent(c.substring(nameEQ.length,c.length));
		}
		return null;
	}


	// Set Cookie if on product page
    if($('body').hasClass('template-product')) {
    	var productUrl = window.location.pathname;
      	setCookie('ysw_last_product', productUrl, 1);
    }

  	// Read Cookie if on cart page
  	if($('body').hasClass('template-cart')) {
      	var last_product = getCookie('ysw_last_product');
		if(last_product) {
			$('.cart-table #cont-shopping').attr('href', last_product);
		}
    }

});

$(window).load(function() {

  	// Give focus to Header Search Input (Desktop Only) if visible
  	if($('.site-header__search .ysw-search-instant-search-input').is(':visible')) {
		//$('.site-header__search .ysw-search-instant-search-input').focus();
    }

  	
    $('.footer--video .video--one .iframe').html('<div class="video-wrapper"><iframe width="560" height="315" src="https://www.youtube.com/embed/BX0NY6q5wqQ?rel=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>');
    

    
    $('.footer--video .video--two .iframe').html('<div class="video-wrapper"><iframe width="560" height="315" src="https://www.youtube.com/embed/tazfcDoFP7c?rel=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>');
    

})

// Lazy Load
var ll = new LazyLoad({
  class_applied: "lz-applied",
  class_loading: "lz-loading",
  class_loaded: "lz-loaded",
  class_error: "lz-error"
});

window.runTimber();
